module.exports = __webpack_public_path__ + "static/media/volume-dark.264f5708.svg";